import Vue from "vue";
import Router from "vue-router";

import home from "../views/home/index";
import userChild from "../views/user_child/index";
import saleOrder from "../views/saleOrder/index";
import publicPoolList from "../views/user_child/publicPoolList";
import StoreManager from "../views/superadmin/store-manager/index";
import StoreFrontAudit from "../views/superadmin/StoreFrontAudit/index";
import LessonManager from "../views/superadmin/lesson-manager/index";
import StoreAdmin from "../views/superadmin/store-admin/index";
import UserByLessonCard from "../views/user-by-lesson-card/index";
import UserBookLesson from "../views/user-book-lesson/index";
import UserBookLessonBs from "../views/user-book-lesson/UserBookLessonBs";
import Admin from "../views/ums/admin/index";
import allocMenuToAdmin from "../views/ums/admin/allocMenuToAdmin";

import StoreLessonCard from "../views/store-lesson-card/index";
import StoreWorkers from "../views/my-store/store-workers/index";

import CancelBookReason from "../views/cancel-book-reason/index";
import SwTeacherSchedulingBs from "../views/my-store/sw-teacher-scheduling-bs/index";

import LessonTemplate from "../views/superadmin/lesson-template/index";
import StoreTag from "../views/superadmin/store-tag/index";
import WorkerPositions from "../views/my-store/worker-positions/index";
import SchedulingTemplate from "../views/my-store/scheduling-template/index";

import LessonLevelSetting from "../views/my-store/lesson-level-setting/index";
import Log from "../views/log/index";
import ActivitySetting from "../views/my-store/activity-setting/index";
import Classroom from "../views/my-store/classroom/index";
import StoreBanner from "../views/my-store/banner/index";
import StoreNews from "../views/my-store/news/index";
import StorePhotoType from "../views/my-store/photo-type/index";
import StorePhoto from "../views/my-store/photo/index";

import Goods from "../views/my-store/goods/index";

import introducerList from "../views/user/introducerList";

import AddWorkerTask from "../views/components/AddWorkerTask";

import StoreSettingSwCirCle from "../views/my-store/store-setting/sw-circle/index";

import StoreInfo from "../views/my-store/store-info/index";
import workingSchedule from "../views/my-store/workingSchedule/index";

import ExceptData from "../views/my-store/export/index";
import FrontBizType from "../views/my-store/bizType/index";

import ChangeCardRecord from "../views/card/change-card-record/index";
import Notify from "../views/my-store/store-setting/notify/index";

import CardConsume from "../views/consume/card-consume/index";
import ShopConsume from "../views/consume/shop-consume/index";
import RevokeCardConsume from "../views/consume/reovke-card-consume/index";
import VccConsume from "../views/consume/vcc-consume/index";
import VccRemCounts from "../views/consume/vcc-rem-counts/index";
import AfterClassService from "../views/service/after-class-service/index";
import CourseEvaluationA from "../views/service/course-evaluation-A/index";
import CourseEvaluationB from "../views/service/course-evaluation-B/index";
import multimediaVip from "../views/service/multimedia-vip/index";
import AfterServiceCfSetting from "../views/my-store/store-setting/after-service-cf/index";
import ExperienceCardConsume from "../views/consume/experience-card-consume/index";

import UserBuyLessonCardBs from "../views/user-by-lesson-card/UserBuyLessonCardBs";

import ClueManager from "../views/marketing-manager/clue-manager";

import ConsumeCardMoneyFc from "../views/busness-analysis/consume-card-money/index";
import ConsumeCardMoneyBs from "../views/busness-analysis/consume-card-money/indexBs";
import PotentialCustomers from "../views/marketing-manager/potential-customers";
import ClueSetting from "../views/marketing-manager/clue-setting/index";
import SalesDataAnalysis from "../views/marketing-manager/sales-data-analysis/index";

import MktJustExp from "../views/marketing-manager/exp-not-vip/index";
import cardConsolidation from "../views/marketing-manager/card-consolidation/index";
import MktVIPSuccessRate from "../views/marketing-manager/buy-card-success/index";
import MktNotExp from "../views/marketing-manager/ask-not-arrived/index";
import MktStorePerformanceStatistics from "../views/marketing-manager/mkt-store-performance-statistics/index";
import MktWorkerPerformanceStatistics from "../views/marketing-manager/mkt-worker-performance-statistics/index";

import BdChildNoSingIn from "../views/base-data/bd-child-no-singin/index";
import BdVIPWillInvalied from "../views/base-data/bd-vip-will-invalied/index";
import BdVIPIsInvalied from "../views/base-data/bd-vip-is-invalied/index";
import BdChildBirthdayArrived from "../views/base-data/bd-child-birthday-arrived/index";
import BdVIPComsumeTimes from "../views/base-data/bd-vip-comsume-times/index";
import BdAnalysisWeek from "../views/base-data/bd-analysis-week/index";
import BdAnalysisTime from "../views/base-data/bd-analysis-time/index";
import BdAnalysisFrequency from "../views/base-data/bd-analysis-frequency/index";
import BdFullClassRate from "../views/base-data/bd-full-class-rate/index";

import BdChildNoSingInBs from "../views/base-data/bd-child-no-singin/indexBs";
import BdVIPWillInvaliedBs from "../views/base-data/bd-vip-will-invalied/indexBs";
import BdVIPIsInvaliedBs from "../views/base-data/bd-vip-is-invalied/indexBs";
import BdChildBirthdayArrivedBs from "../views/base-data/bd-child-birthday-arrived/indexBs";
import BdVIPComsumeTimesBs from "../views/base-data/bd-vip-comsume-times/indexBs";
import BdAnalysisWeekBs from "../views/base-data/bd-analysis-week/indexBs";
import BdAnalysisTimeBs from "../views/base-data/bd-analysis-time/indexBs";
import BdAnalysisFrequencyBs from "../views/base-data/bd-analysis-frequency/indexBs";
import BdFullClassRateBs from "../views/base-data/bd-full-class-rate/indexBs";

import MAConsume from "../views/market-analysis/ma-consume/index";
import MASaleUserUnitProce from "../views/market-analysis/ma-sale-user-unit-proce/index";
import MACardUnitProce from "../views/market-analysis/ma-card-unit-proce/index";
import MAMonthOnMonth from "../views/market-analysis/ma-month-on-month/index";
import MAIncomeAnalysis from "../views/market-analysis/ma-income-analysis/index";
import MACardRem from "../views/market-analysis/ma-card-rem/index";
import MACardFinished from "../views/market-analysis/ma-card-finished/index";

import MAConsumeBs from "../views/market-analysis/ma-consume/indexBs";
import MASaleUserUnitProceBs from "../views/market-analysis/ma-sale-user-unit-proce/indexBs";
import MACardUnitProceBs from "../views/market-analysis/ma-card-unit-proce/indexBs";
import MAMonthOnMonthBs from "../views/market-analysis/ma-month-on-month/indexBs";
import MAIncomeAnalysisBs from "../views/market-analysis/ma-income-analysis/indexBs";
import MACardRemBs from "../views/market-analysis/ma-card-rem/indexBs";
import MACardFinishedBs from "../views/market-analysis/ma-card-finished/indexBs";

import SalaryCommissonTemplate from "../views/my-store/salary-commisson/index";
import StoreLessonCardSubType from "../views/store-lesson-card-sub-type/index";

import vmallBrand from "../views/store-lesson-card-sub-type/index";
import goldRecord from "../views/gold/index";

Vue.use(Router);
import Layout from "../views/layout/Layout";

/**
 * 不管是什么账号必须有的
 * @type {*[]}
 */
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: home,
        meta: { title: "首页", icon: "home" },
      },
    ],
  },
  {
    path: "/backMini",
    name: "backMini",
    component: () => import("@/views/back-mini/index"),
  },
];

export const asyncRouterMap = [
  {
    path: "/vip",
    component: Layout,
    redirect: "/vip/update",
    name: "vip",
    meta: { title: "客户管理", icon: "user" },
    children: [
      {
        path: "userChild",
        name: "userChild",
        component: userChild,
        meta: {
          title: "客户信息",
          icon: "user",
          keepAlive: true,
        },
      },
      {
        path: "saleOrder",
        name: "saleOrder",
        component: saleOrder,
        meta: {
          title: "销售订单",
          icon: "user",
          keepAlive: true,
        },
      },
      {
        path: "StoreLessonCard",
        name: "StoreLessonCard",
        component: StoreLessonCard,
        meta: { title: "卡类型管理" },
        hidden: true,
      },
      {
        path: "StoreLessonCardSubType",
        name: "StoreLessonCardSubType",
        component: StoreLessonCardSubType,
        meta: { title: "卡子类型管理" },
        hidden: true,
      },

      {
        path: "UserBuyLessonCardBs",
        name: "UserBuyLessonCardBs",
        component: UserBuyLessonCardBs,
        meta: { title: "基础会员列表" },
        hidden: true,
      },

      {
        path: "UserByLessonCard",
        name: "UserByLessonCard",
        component: UserByLessonCard,
        meta: { title: "亲子游会员列表" },
        hidden: true,
      },
      {
        path: "introducerList",
        name: "introducerList",
        component: introducerList,
        meta: { title: "裂变会员列表", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "publicPoolList",
        name: "publicPoolList",
        component: publicPoolList,
        meta: { title: "公共池列表", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "VIPDetail",
        name: "VIPDetail",
        component: () => import("@/views/vip-detail/index"),
        meta: { title: "会员详情" },
        hidden: true,
      },
      {
        path: "ChangeCardRecord",
        name: "ChangeCardRecord",
        component: ChangeCardRecord,
        meta: { title: "卡变更日志" },
        hidden: true,
      },
      {
        path: "goldRecord",
        name: "goldRecord",
        component: goldRecord,
        meta: { title: "金币列表" },
        hidden: true,
      },
      {
        path: "childPhotoList",
        name: "childPhotoList",
        component: () => import("@/views/components/ChildPhotoList"),
        meta: { title: "会员照片墙", showHis: false },
        hidden: true,
      },
      {
        path: "addChildPhoto",
        name: "addChildPhoto",
        component: () => import("@/views/components/addChildPhoto"),
        meta: { title: "添加照片", showHis: false },
        hidden: true,
      },
      {
        path: "agreement",
        name: "agreement",
        component: () => import("@/views/user-by-lesson-card/agreement"),
        meta: { title: "合同附件", showHis: false },
        hidden: true,
      },
    ],
  },

  {
    path: "/lesson",
    component: Layout,
    redirect: "/lesson/admin",
    name: "lesson",
    meta: { title: "课程管理", icon: "el-icon-message-solid" },
    children: [
      {
        path: "UserBookLesson",
        name: "UserBookLesson",
        component: UserBookLesson,
        meta: { title: "", icon: "el-icon-thumb" },
      },
      {
        path: "UserBookLessonBs",
        name: "UserBookLessonBs",
        component: UserBookLessonBs,
        meta: { title: "基础课程预约", icon: "el-icon-thumb" },
      },
      {
        path: "RegularBook",
        name: "RegularBook",
        component: () => import("@/views/user-book-lesson/RegularBook"),
        meta: { title: "固定课", icon: "el-icon-thumb" },
      },

      {
        path: "LessonLevelSetting",
        name: "LessonLevelSetting",
        component: LessonLevelSetting,
        meta: { title: "课程设置" },
        hidden: true,
      },
      {
        path: "ActivitySetting",
        name: "ActivitySetting",
        component: ActivitySetting,
        meta: { title: "活动设置", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "SchedulingTemplate",
        name: "SchedulingTemplate",
        component: SchedulingTemplate,
        meta: { title: "亲子排课", icon: "el-icon-thumb" },
        hidden: true,
      },

      {
        path: "SwTeacherSchedulingBs",
        name: "SwTeacherSchedulingBs",
        component: SwTeacherSchedulingBs,
        meta: { title: "基础排班", icon: "el-icon-thumb" },
        hidden: true,
      },
      // {
      //   path: 'CancelBookReason',
      //   name: 'CancelBookReason',
      //   component: CancelBookReason,
      //   meta: {title: '取消课程原因'},
      //   hidden: true
      // },
      // {
      //   path: 'ReleaseLessons',
      //   name: 'ReleaseLessons',
      //   component: ReleaseLessons,
      //   meta: {title: '课程预约设置', icon: 'el-icon-thumb'}
      // },

      {
        path: "InvaliedBooked",
        name: "InvaliedBooked",
        component: () => import("@/views/user-book-lesson/InvaliedBooked"),
        meta: { title: "覆盖预约列表", icon: "el-icon-thumb" },
      },
    ],
  },

  {
    path: "/Consume",
    component: Layout,
    redirect: "/Consume/CardConsume",
    name: "Consume",
    meta: { title: "消费管理", icon: "el-icon-message-solid" },
    children: [
      {
        path: "CardConsume",
        name: "CardConsume",
        component: CardConsume,
        meta: { title: "会员消费列表", icon: "el-icon-thumb" },
      },
      {
        path: "shopConsume",
        name: "shopConsume",
        component: ShopConsume,
        meta: { title: "商品消费管理", icon: "el-icon-thumb" },
      },
      {
        path: "ExperienceCardConsume",
        name: "ExperienceCardConsume",
        component: ExperienceCardConsume,
        meta: { title: "体验消费列表", icon: "el-icon-thumb" },
      },

      {
        path: "RevokeCardConsume",
        name: "RevokeCardConsume",
        component: RevokeCardConsume,
        meta: { title: "消费撤销记录", icon: "el-icon-thumb" },
      },
      {
        path: "VccConsume",
        name: "VccConsume",
        component: VccConsume,
        meta: { title: "短信消费记录", icon: "el-icon-thumb" },
      },
      {
        path: "VccRemCounts",
        name: "VccRemCounts",
        component: VccRemCounts,
        meta: { title: "短信余额查询", icon: "el-icon-thumb" },
      },
    ],
  },
  //服务
  {
    path: "/service",
    component: Layout,
    redirect: "/service/AfterServiceCfSetting",
    name: "service",
    meta: { title: "服务", icon: "el-icon-message-solid" },
    children: [
      {
        path: "AfterServiceCfSetting",
        name: "AfterServiceCfSetting",
        component: AfterServiceCfSetting,
        meta: { title: "亲子课评设置", icon: "el-icon-thumb" },
      },
      {
        path: "AfterClassService",
        name: "AfterClassService",
        component: AfterClassService,
        meta: { title: "课后服务", icon: "el-icon-thumb" },
      },
      {
        path: "StoreSettingSwCirCle",
        name: "StoreSettingSwCirCle",
        component: StoreSettingSwCirCle,
        meta: { title: "泳圈信息", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "CourseEvaluationA",
        name: "CourseEvaluationA",
        component: CourseEvaluationA,
        meta: { title: "A课评", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "CourseEvaluationB",
        name: "CourseEvaluationB",
        component: CourseEvaluationB,
        meta: { title: "A课评", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "multimediaVip",
        name: "multimediaVip",
        component: multimediaVip,
        meta: { title: "多媒体VIP", icon: "el-icon-thumb" },
        hidden: true,
      },
      // {
      //   path: 'CustomerPhoto',
      //   name: 'CustomerPhoto',
      //   component: AfterClassService,
      //   meta: {title: '会员相册', icon: 'el-icon-thumb'},
      // },
    ],
  },
  // 营销管理
  {
    path: "/MarketingManager",
    component: Layout,
    redirect: "/MarketingManager",
    name: "MarketingManager",
    meta: { title: "营销管理", icon: "el-icon-message-solid" },
    children: [
      {
        path: "PotentialCustomers",
        name: "PotentialCustomers",
        component: PotentialCustomers,
        meta: { title: "潜在客户管理", icon: "el-icon-thumb" },
      },
      {
        path: "ClueManager",
        name: "ClueManager",
        component: ClueManager,
        meta: { title: "线索管理", icon: "el-icon-thumb" },
      },
      {
        path: "ClueSetting",
        name: "ClueSetting",
        component: ClueSetting,
        meta: { title: "线索设置", icon: "el-icon-thumb" },
      },
      // {
      //   path: 'MktExpStatistics',
      //   name: 'MktExpStatistics',
      //   component: MktExpStatistics,
      //   meta: {title: '体验统计', icon: 'el-icon-thumb'}
      // },
      {
        path: "SalesDataAnalysis",
        name: "SalesDataAnalysis",
        component: SalesDataAnalysis,
        meta: { title: "销售数据分析", icon: "el-icon-thumb" },
      },
      {
        path: "cardConsolidation",
        name: "cardConsolidation",
        component: cardConsolidation,
        meta: { title: "办卡合并页面", icon: "el-icon-thumb" },
      },
      {
        path: "MktVIPSuccessRate",
        name: "MktVIPSuccessRate",
        component: MktVIPSuccessRate,
        meta: { title: "办卡成功率", icon: "el-icon-thumb" },
      },
      {
        path: "MktJustExp",
        name: "MktJustExp",
        component: MktJustExp,
        meta: { title: "体验未办卡", icon: "el-icon-thumb" },
      },
      {
        path: "MktNotExp",
        name: "MktNotExp",
        component: MktNotExp,
        meta: { title: "咨询未到店", icon: "el-icon-thumb" },
      },
      {
        path: "MktStorePerformanceStatistics",
        name: "MktStorePerformanceStatistics",
        component: MktStorePerformanceStatistics,
        meta: { title: "门店业绩统计", icon: "el-icon-thumb" },
      },
    ],
  },

  // 经营分析(亲子)
  {
    path: "/BusinessAnalysis",
    component: Layout,
    redirect: "/BusinessAnalysis",
    name: "BusinessAnalysis",
    meta: { title: "经营分析(亲子)", icon: "el-icon-message-solid" },
    children: [
      {
        path: "ConsumeCardMoneyFc",
        name: "ConsumeCardMoneyFc",
        component: ConsumeCardMoneyFc,
        meta: { title: "耗卡金额(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "MAConsume",
        name: "MAConsume",
        component: MAConsume,
        meta: { title: "消费", icon: "el-icon-thumb" },
      },
      {
        path: "MASaleUserUnitProce",
        name: "MASaleUserUnitProce",
        component: MASaleUserUnitProce,
        meta: { title: "销售客单价(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "MACardUnitProce",
        name: "MACardUnitProce",
        component: MACardUnitProce,
        meta: { title: "耗卡客单价(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "MAMonthOnMonth",
        name: "MAMonthOnMonth",
        component: MAMonthOnMonth,
        meta: { title: "环比(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "MAIncomeAnalysis",
        name: "MAIncomeAnalysis",
        component: MAIncomeAnalysis,
        meta: { title: "收入分析(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "MACardRem",
        name: "MACardRem",
        component: MACardRem,
        meta: { title: "未完成次数及金额(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "MACardFinished",
        name: "MACardFinished",
        component: MACardFinished,
        meta: { title: "已完成金额(亲子)", icon: "el-icon-thumb" },
      },
    ],
  },

  // 经营分析(基础)
  {
    path: "/BusinessAnalysisBs",
    component: Layout,
    redirect: "/BusinessAnalysisBs",
    name: "BusinessAnalysisBs",
    meta: { title: "经营分析(亲子)", icon: "el-icon-message-solid" },
    children: [
      {
        path: "ConsumeCardMoneyBs",
        name: "ConsumeCardMoneyBs",
        component: ConsumeCardMoneyBs,
        meta: { title: "基础耗卡金额", icon: "el-icon-thumb" },
      },

      {
        path: "MASaleUserUnitProceBs",
        name: "MASaleUserUnitProceBs",
        component: MASaleUserUnitProceBs,
        meta: { title: "销售客单价(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "MACardUnitProceBs",
        name: "MACardUnitProceBs",
        component: MACardUnitProceBs,
        meta: { title: "耗卡客单价(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "MAMonthOnMonthBs",
        name: "MAMonthOnMonthBs",
        component: MAMonthOnMonthBs,
        meta: { title: "环比(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "MAIncomeAnalysisBs",
        name: "MAIncomeAnalysisBs",
        component: MAIncomeAnalysisBs,
        meta: { title: "收入分析(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "MACardRemBs",
        name: "MACardRemBs",
        component: MACardRemBs,
        meta: { title: "未完成次数及金额(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "Bs",
        name: "MACardFinishedBs",
        component: MACardFinishedBs,
        meta: { title: "已完成金额(基础)", icon: "el-icon-thumb" },
      },
    ],
  },
  //基本资料查询(亲子)
  {
    path: "/BaseData",
    component: Layout,
    redirect: "/BaseData",
    name: "BaseData",
    meta: { title: "基本资料(亲子)", icon: "el-icon-message-solid" },
    children: [
      {
        path: "BdChildNoSingIn",
        name: "BdChildNoSingIn",
        component: BdChildNoSingIn,
        meta: { title: "未到店消费(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "BdVIPWillInvalied",
        name: "BdVIPWillInvalied",
        component: BdVIPWillInvalied,
        meta: { title: "将要过期客户(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "BdVIPIsInvalied",
        name: "BdVIPIsInvalied",
        component: BdVIPIsInvalied,
        meta: { title: "过期客户(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "BdChildBirthdayArrived",
        name: "BdChildBirthdayArrived",
        component: BdChildBirthdayArrived,
        meta: { title: "会员生日(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "BdVIPComsumeTimes",
        name: "BdVIPComsumeTimes",
        component: BdVIPComsumeTimes,
        meta: { title: "消费频次排行(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "BdAnalysisWeek",
        name: "BdAnalysisWeek",
        component: BdAnalysisWeek,
        meta: { title: "周分析(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "BdAnalysisTime",
        name: "BdAnalysisTime",
        component: BdAnalysisTime,
        meta: { title: "时段分析(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "BdAnalysisFrequency",
        name: "BdAnalysisFrequency",
        component: BdAnalysisFrequency,
        meta: { title: "频率分析(亲子)", icon: "el-icon-thumb" },
      },
      {
        path: "BdFullClassRate",
        name: "BdFullClassRate",
        component: BdFullClassRate,
        meta: { title: "满课率(亲子)", icon: "el-icon-thumb" },
      },
    ],
  },
  //基本资料查询(基础)
  {
    path: "/BaseDataBs",
    component: Layout,
    redirect: "/BaseDataBs",
    name: "BaseDataBs",
    meta: { title: "基本资料(基础)", icon: "el-icon-message-solid" },
    children: [
      {
        path: "BdChildNoSingInBs",
        name: "BdChildNoSingInBs",
        component: BdChildNoSingInBs,
        meta: { title: "未到店消费(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "BdVIPWillInvaliedBs",
        name: "BdVIPWillInvaliedBs",
        component: BdVIPWillInvaliedBs,
        meta: { title: "将要过期客户(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "BdVIPIsInvaliedBs",
        name: "BdVIPIsInvaliedBs",
        component: BdVIPIsInvaliedBs,
        meta: { title: "过期客户(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "BdChildBirthdayArrivedBs",
        name: "BdChildBirthdayArrivedBs",
        component: BdChildBirthdayArrivedBs,
        meta: { title: "会员生日(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "BdVIPComsumeTimesBs",
        name: "BdVIPComsumeTimesBs",
        component: BdVIPComsumeTimesBs,
        meta: { title: "消费频次排行(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "BdAnalysisWeekBs",
        name: "BdAnalysisWeekBs",
        component: BdAnalysisWeekBs,
        meta: { title: "周分析(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "BdAnalysisTimeBs",
        name: "BdAnalysisTimeBs",
        component: BdAnalysisTimeBs,
        meta: { title: "时段分析(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "BdAnalysisFrequencyBs",
        name: "BdAnalysisFrequencyBs",
        component: BdAnalysisFrequencyBs,
        meta: { title: "频率分析(基础)", icon: "el-icon-thumb" },
      },
      {
        path: "BdFullClassRateBs",
        name: "BdFullClassRateBs",
        component: BdFullClassRateBs,
        meta: { title: "满课率(基础)", icon: "el-icon-thumb" },
      },
    ],
  },
  //员工管理
  {
    path: "/StaffManagement",
    component: Layout,
    redirect: "/StaffManagement/AfterServiceCfSetting",
    name: "StaffManagement",
    meta: { title: "员工管理", icon: "el-icon-message-solid" },
    children: [
      {
        path: "frequencyTable",
        name: "frequencyTable",
        component: () =>
          import("@/views/my-store/store-workers/frequencyTable"),
        meta: { title: "频率表", icon: "el-icon-thumb" },
      },
      {
        path: "StoreWorkers",
        name: "StoreWorkers",
        component: StoreWorkers,
        // meta: { title: "员工信息", icon: "el-icon-thumb" },
        meta: { title: "员工列表", icon: "el-icon-thumb" },
      },
      {
        path: "clockInRecords",
        name: "clockInRecords",
        component: () =>
          import("@/views/my-store/store-workers/clockInRecords"),
        meta: { title: "打卡记录", icon: "el-icon-thumb" },
      },
      {
        path: "confirmationOfClass",
        name: "confirmationOfClass",
        component: () =>
          import("@/views/my-store/store-workers/confirmationOfClass"),
        meta: { title: "B课时确认", icon: "el-icon-thumb" },
      },
      {
        path: "salaryTable",
        name: "salaryTable",
        component: () => import("@/views/my-store/store-workers/salaryTable"),
        meta: { title: "薪资表", icon: "el-icon-thumb" },
      },
      {
        path: "schedule",
        name: "schedule",
        component: () => import("@/views/my-store/store-workers/schedule"),
        meta: { title: "排班表", icon: "el-icon-thumb" },
      },
      {
        path: "workArrangement",
        name: "workArrangement",
        component: () =>
          import("@/views/my-store/store-workers/workArrangement"),
        meta: { title: "工作安排", icon: "el-icon-thumb" },
      },
      {
        path: "WorkerPositions",
        name: "WorkerPositions",
        component: WorkerPositions,
        meta: { title: "职位管理", icon: "el-icon-thumb" },
      },
      {
        path: "MktWorkerPerformanceStatistics",
        name: "MktWorkerPerformanceStatistics",
        component: MktWorkerPerformanceStatistics,
        meta: { title: "个人业绩统计", icon: "el-icon-thumb" },
      },
      {
        path: "SalaryCommissonTemplate",
        name: "SalaryCommissonTemplate",
        component: SalaryCommissonTemplate,
        meta: { title: "薪资模板", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "WorkerTask",
        name: "WorkerTask",
        component: () => import("@/views/my-store/worker-task/index"),
        meta: { title: "任务管理", icon: "el-icon-thumb" },
      },
      {
        path: "addFile",
        name: "addFile",
        component: () => import("@/views/components/addFile"),
        meta: { title: "文件管理", showHis: false },
        hidden: true,
      },
      {
        path: "means",
        name: "means",
        component: () => import("@/views/my-store/store-workers/means"),
        meta: { title: "文件管理", showHis: false },
        hidden: true,
      },
      {
        path: "followHis",
        name: "followHis",
        component: () => import("@/views/my-store/store-workers/followHis"),
        meta: { title: "跟进历史", showHis: false },
        hidden: true,
      },
    ],
  },

  {
    path: "/myStore",
    component: Layout,
    redirect: "/myStore",
    name: "myStore",
    meta: { title: "我的门店", icon: "el-icon-s-custom" },
    children: [
      {
        path: "StoreInfo",
        name: "StoreInfo",
        component: StoreInfo,
        meta: { title: "门店信息", icon: "el-icon-thumb" },
      },
      {
        path: "workingSchedule",
        name: "workingSchedule",
        component: workingSchedule,
        meta: { title: "门店设置", icon: "el-icon-thumb" },
      },
      {
        path: "Classroom",
        name: "Classroom",
        component: Classroom,
        meta: { title: "教室", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "StoreBanner",
        name: "StoreBanner",
        component: StoreBanner,
        meta: { title: "轮播图管理", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "StoreNews",
        name: "StoreNews",
        component: StoreNews,
        meta: { title: "门店动态", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "StorePhoto",
        name: "StorePhoto",
        component: StorePhoto,
        meta: { title: "门店照片", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "StorePhotoType",
        name: "StorePhotoType",
        component: StorePhotoType,
        meta: { title: "门店照片类型", icon: "el-icon-thumb" },
        hidden: true,
      },

      {
        path: "Goods",
        name: "Goods",
        component: Goods,
        meta: { title: "商品", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "AddWorkerTask",
        name: "AddWorkerTask",
        component: AddWorkerTask,
        meta: { title: "添加任务", showHis: false, icon: "el-icon-thumb" },
        hidden: true,
      },

      {
        path: "WorkerTaskDetail",
        name: "WorkerTaskDetail",
        component: () =>
          import("@/views/my-store/worker-task/WorkerTaskDetail"),
        meta: { title: "任务详情", showHis: false, icon: "el-icon-thumb" },
        hidden: true,
      },

      {
        path: "Notify",
        name: "Notify",
        component: Notify,
        meta: { title: "消息发送配置", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "ChangeVipPhone",
        name: "ChangeVipPhone",
        component: () => import("@/views/my-store/change-phone/index"),
        meta: { title: "修改手机号", icon: "el-icon-thumb" },
      },

      {
        path: "ExceptData",
        name: "ExceptData",
        component: ExceptData,
        meta: { title: "数据导入", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "FrontBizType",
        name: "FrontBizType",
        component: FrontBizType,
        meta: { title: "异业配置", icon: "el-icon-thumb" },
        hidden: true,
      },
    ],
  },

  {
    path: "/ums",
    component: Layout,
    redirect: "/ums",
    name: "ums",
    meta: { title: "账号管理", icon: "ums-admin" },
    children: [
      {
        path: "Admin",
        name: "Admin",
        component: Admin,
        meta: { title: "账号", icon: "ums-admin" },
      },
      {
        path: "allocMenuToAdmin",
        name: "allocMenuToAdmin",
        component: allocMenuToAdmin,
        meta: { title: "分配权限", icon: "ums-admin" },
        hidden: true,
      },
    ],
  },
  // {
  //   path:'/log',
  //   component: Layout,
  //   redirect: '/log',
  //   name: 'log',
  //   meta: {title: '日志', icon: 'ums-admin'},
  //   children: [
  //     {
  //       path: 'Log',
  //       name: 'Log',
  //       component: Log,
  //       meta: {title: '操作日志', icon: 'ums-admin'}
  //     }
  //   ]
  // },

  {
    path: "/sms",
    component: Layout,
    redirect: "/sms",
    name: "sms",
    meta: { title: "营销", icon: "sms" },
    children: [
      {
        path: "flash",
        name: "flash",
        component: () => import("@/views/mall/sms/flash/index"),
        meta: { title: "秒杀活动列表", icon: "sms-flash" },
      },
      {
        path: "flashSession",
        name: "flashSession",
        component: () => import("@/views/mall/sms/flash/sessionList"),
        meta: { title: "秒杀时间段列表", showHis: false },
        hidden: true,
      },
      {
        path: "selectSession",
        name: "selectSession",
        component: () => import("@/views/mall/sms/flash/selectSessionList"),
        meta: { title: "秒杀时间段选择", showHis: false },
        hidden: true,
      },
      {
        path: "flashProductRelation",
        name: "flashProductRelation",
        component: () => import("@/views/mall/sms/flash/productRelationList"),
        meta: { title: "秒杀商品列表", showHis: false },
        hidden: true,
      },

      {
        path: "couponTemplate",
        name: "couponTemplate",
        component: () => import("@/views/mall/sms/coupon-template/index"),
        meta: { title: "优惠券模板", icon: "el-icon-thumb" },
      },
      {
        path: "addCouponTemplate",
        name: "addCouponTemplate",
        component: () => import("@/views/mall/sms/coupon-template/add"),
        meta: { title: "添加优惠券模板", showHis: false },
        hidden: true,
      },
      {
        path: "updateCouponTemplate",
        name: "updateCouponTemplate",
        component: () => import("@/views/mall/sms/coupon-template/update"),
        meta: { title: "修改优惠券模板", showHis: false },
        hidden: true,
      },
      {
        path: "DistributionCoupon",
        name: "DistributionCoupon",
        component: () =>
          import(
            "@/views/mall/sms/coupon-template/components/DistributeCoupon"
          ),
        meta: { title: "派发优惠券", showHis: false },
        hidden: true,
      },

      {
        path: "coupon",
        name: "coupon",
        component: () => import("@/views/mall/sms/coupon/index"),
        meta: { title: "优惠券列表", icon: "el-icon-thumb" },
      },
      {
        path: "addCoupon",
        name: "addCoupon",
        component: () => import("@/views/mall/sms/coupon/add"),
        meta: { title: "添加优惠券", showHis: false },
        hidden: true,
      },
      {
        path: "updateCoupon",
        name: "updateCoupon",
        component: () => import("@/views/mall/sms/coupon/update"),
        meta: { title: "修改优惠券", showHis: false },
        hidden: true,
      },
      {
        path: "couponHistory",
        name: "couponHistory",
        component: () => import("@/views/mall/sms/coupon/history"),
        meta: { title: "优惠券领取详情", showHis: false },
        hidden: true,
      },
      // {
      //   path: 'brand',
      //   name: 'homeBrand',
      //   component: () => import('@/views/mall/sms/brand/index'),
      //   meta: {title: '品牌推荐', icon: 'product-brand'}
      // },
      // {
      //   path: 'new',
      //   name: 'homeNew',
      //   component: () => import('@/views/mall/sms/new/index'),
      //   meta: {title: '新品推荐', icon: 'sms-new'}
      // },
      // {
      //   path: 'hot',
      //   name: 'homeHot',
      //   component: () => import('@/views/mall/sms/hot/index'),
      //   meta: {title: '人气推荐', icon: 'sms-hot'}
      // },
      // {
      //   path: 'subject',
      //   name: 'homeSubject',
      //   component: () => import('@/views/mall/sms/subject/index'),
      //   meta: {title: '专题推荐', icon: 'sms-subject'}
      // },
      // {
      //   path: 'advertise',
      //   name: 'homeAdvertise',
      //   component: () => import('@/views/mall/sms/advertise/index'),
      //   meta: {title: '广告列表', icon: 'sms-ad'}
      // },
      // {
      //   path: 'addAdvertise',
      //   name: 'addHomeAdvertise',
      //   component: () => import('@/views/mall/sms/advertise/add'),
      //   meta: {title: '添加广告'},
      //   hidden:true
      // },
      // {
      //   path: 'updateAdvertise',
      //   name: 'updateHomeAdvertise',
      //   component: () => import('@/views/mall/sms/advertise/update'),
      //   meta: {title: '编辑广告'},
      //   hidden:true
      // }
    ],
  },

  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: { title: "商品", icon: "product" },
    children: [
      {
        path: "brand",
        name: "brand",
        component: () => import("@/views/mall/pms/brand/index"),
        meta: { title: "品牌管理", icon: "product-brand" },
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/mall/pms/productCate/index"),
        meta: { title: "商品分类", icon: "product-cate" },
      },
      {
        path: "productAttr",
        name: "productAttr",
        component: () => import("@/views/mall/pms/productAttr/index"),
        meta: { title: "商品类型", icon: "product-attr" },
      },
      {
        path: "product",
        name: "product",
        component: () => import("@/views/mall/pms/product/index"),
        meta: { title: "商品列表", icon: "product-list" },
      },

      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/mall/pms/product/add"),
        hidden: true,
        meta: { title: "添加商品", icon: "product-add", showHis: false },
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/mall/pms/product/update"),
        meta: { title: "修改商品", icon: "product-add", showHis: false },
        hidden: true,
      },

      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/mall/pms/productCate/add"),
        meta: { title: "添加商品分类", showHis: false },
        hidden: true,
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/mall/pms/productCate/update"),
        meta: { title: "修改商品分类", showHis: false },
        hidden: true,
      },

      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/mall/pms/productAttr/productAttrList"),
        meta: { title: "商品属性列表", showHis: false },
        hidden: true,
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/mall/pms/productAttr/addProductAttr"),
        meta: { title: "添加商品属性", showHis: false },
        hidden: true,
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () =>
          import("@/views/mall/pms/productAttr/updateProductAttr"),
        meta: { title: "修改商品属性", showHis: false },
        hidden: true,
      },

      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/mall/pms/brand/add"),
        meta: { title: "添加品牌", showHis: false },
        hidden: true,
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/mall/pms/brand/update"),
        meta: { title: "编辑品牌", showHis: false },
        hidden: true,
      },

      {
        path: "supplier",
        name: "supplier",
        component: () => import("@/views/mall/pms/orderSupplier/index"),
        meta: { title: "商品供货商" },
        hidden: true,
      },

      {
        path: "addSupplier",
        name: "addSupplier",
        component: () => import("@/views/mall/pms/orderSupplier/add"),
        meta: { title: "添加商品供货商", showHis: false },
        hidden: true,
      },

      {
        path: "updateSupplier",
        name: "updateSupplier",
        component: () => import("@/views/mall/pms/orderSupplier/update"),
        meta: { title: "修改商品供货商", showHis: false },
        hidden: true,
      },
    ],
  },

  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    meta: { title: "订单", icon: "order" },
    children: [
      {
        path: "order",
        name: "order",
        component: () => import("@/views/mall/oms/order/index"),
        meta: { title: "订单列表", icon: "product-list" },
      },
      {
        path: "orderDelivery",
        name: "orderDelivery",
        component: () => import("@/views/mall/oms/delivery/index"),
        meta: { title: "订单物流列表", icon: "product-list" },
      },

      {
        path: "importDelivery",
        name: "importDelivery",
        component: () => import("@/views/mall/oms/delivery/importDelivery"),
        meta: { title: "导入物流单号", icon: "product-list", showHis: false },
        hidden: true,
      },
      {
        path: "deliverOrderList",
        name: "deliverOrderList",
        component: () => import("@/views/mall/oms/order/deliverOrderList"),
        meta: { title: "发货列表", showHis: false },
        hidden: true,
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/mall/oms/order/orderDetail"),
        meta: { title: "订单详情", showHis: false },
        hidden: true,
      },
      // {
      //   path: 'orderSetting',
      //   name: 'orderSetting',
      //   component: () => import('@/views/mall/oms/order/setting'),
      //   meta: {title: '订单设置', icon: 'order-setting'}
      // },
      {
        path: "returnApply",
        name: "returnApply",
        component: () => import("@/views/mall/oms/apply/index"),
        meta: { title: "退货申请处理", icon: "order-return" },
      },
      {
        path: "returnReason",
        name: "returnReason",
        component: () => import("@/views/mall/oms/apply/reason"),
        meta: { title: "退货原因设置", icon: "order-return-reason" },
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/mall/oms/apply/applyDetail"),
        meta: { title: "退货原因详情", showHis: false },
        hidden: true,
      },
      {
        path: "companyAddress",
        name: "companyAddress",
        component: () => import("@/views/mall/company/index"),
        meta: { title: "仓储地址" },
      },
      {
        path: "addCompanyAddress",
        name: "addCompanyAddress",
        component: () => import("@/views/mall/company/add"),
        meta: { title: "添加地址", showHis: false },
        hidden: true,
      },
      {
        path: "updateCompanyAddress",
        name: "updateCompanyAddress",
        component: () => import("@/views/mall/company/update"),
        meta: { title: "修改地址", showHis: false },
        hidden: true,
      },
    ],
  },

  {
    path: "/ams",
    component: Layout,
    redirect: "/ams",
    name: "ams",
    meta: { title: "活动", icon: "product" },
    children: [
      {
        path: "activityBanner",
        name: "activityBanner",
        component: () => import("@/views/mall/ams/banner/index"),
        meta: { title: "活动轮播图", icon: "product-list" },
      },
      {
        path: "addAmsBanner",
        name: "addAmsBanner",
        component: () => import("@/views/mall/ams/banner/add"),
        meta: { title: "添加活动图", showHis: false },
        hidden: true,
      },
      {
        path: "updateAmsBanner",
        name: "updateAmsBanner",
        component: () => import("@/views/mall/ams/banner/update"),
        meta: { title: "修改活动图", showHis: false },
        hidden: true,
      },
    ],
  },

  {
    path: "/superAdmin",
    component: Layout,
    redirect: "/superAdmin",
    name: "superAdmin",
    meta: { title: "超级管理员", icon: "ums-admin" },
    children: [
      {
        path: "StoreManager",
        name: "StoreManager",
        component: StoreManager,
        meta: { title: "店铺管理", icon: "ums-admin" },
      },
      {
        path: "LessonManager",
        name: "LessonManager",
        component: LessonManager,
        meta: { title: "课程购买管理", icon: "el-icon-thumb" },
      },
      {
        path: "LessonTemplate",
        name: "LessonTemplate",
        component: LessonTemplate,
        meta: { title: "课程模板管理", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "StoreAdmin",
        name: "StoreAdmin",
        component: StoreAdmin,
        meta: { title: "店铺管理员", icon: "el-icon-thumb" },
        hidden: true,
      },
      {
        path: "StoreTag",
        name: "StoreTag",
        component: StoreTag,
        meta: { title: "门店标签", icon: "el-icon-thumb" },
        hidden: true,
      },
    ],
  },

  {
    path: "/vMall",
    component: Layout,
    redirect: "/vMall/product",
    name: "vMall",
    meta: { title: "虚拟商城", icon: "el-icon-s-custom" },
    children: [
      {
        path: "vMallProduct",
        name: "vMallProduct",
        component: () => import("@/views/vMall/pms/product/index"),
        meta: { title: "商品列表", icon: "product-list" },
      },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/vMall/pms/product/add"),
        hidden: true,
        meta: { title: "添加商品", icon: "product-add", showHis: false },
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/vMall/pms/product/update"),
        meta: { title: "修改商品", icon: "product-add", showHis: false },
        hidden: true,
      },
      {
        path: "vMallOrder",
        name: "vMallOrder",
        component: () => import("@/views/vMall/oms/order/index"),
        meta: { title: "订单列表", icon: "" },
      },
      {
        path: "vMallDeliverOrderList",
        name: "vMallDeliverOrderList",
        component: () => import("@/views/vMall/oms/delivery/index"),
        meta: { title: "订单配送列表", icon: "" },
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/vMall/oms/order/orderDetail"),
        meta: { title: "订单详情", showHis: false },
        hidden: true,
      },
    ],
  },

  {
    path: "/storeManager",
    component: Layout,
    redirect: "/storeManager/product",
    name: "storeManager",
    meta: { title: "门店管理", icon: "ums-admin" },
    children: [
      {
        path: "StoreFrontAudit",
        name: "StoreFrontAudit",
        component: StoreFrontAudit,
        meta: { title: "商户入驻", icon: "ums-admin" },
      },
      {
        path: "vMallBrand",
        name: "vMallBrand",
        component: () => import("@/views/vMall/pms/brand/index"),
        meta: { title: "品牌管理", icon: "product-brand" },
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/vMall/pms/brand/add"),
        meta: { title: "添加品牌", showHis: false },
        hidden: true,
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/vMall/pms/brand/update"),
        meta: { title: "编辑品牌", showHis: false },
        hidden: true,
      },
      {
        path: "vMallSupplier",
        name: "vMallSupplier",
        component: () => import("@/views/vMall/pms/orderSupplier/index"),
        meta: { title: "商品供货商" },
        hidden: true,
      },
      {
        path: "addSupplier",
        name: "addSupplier",
        component: () => import("@/views/vMall/pms/orderSupplier/add"),
        meta: { title: "添加商品供货商", showHis: false },
        hidden: true,
      },
      {
        path: "updateSupplier",
        name: "updateSupplier",
        component: () => import("@/views/vMall/pms/orderSupplier/update"),
        meta: { title: "修改商品供货商", showHis: false },
        hidden: true,
      },
      {
        path: "vMallProductCate",
        name: "vMallProductCate",
        component: () => import("@/views/vMall/pms/productCate/index"),
        meta: { title: "商品分类", icon: "product-cate" },
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/vMall/pms/productCate/add"),
        meta: { title: "添加商品分类", showHis: false },
        hidden: true,
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/vMall/pms/productCate/update"),
        meta: { title: "修改商品分类", showHis: false },
        hidden: true,
      },
      {
        path: "vMallProductAttr",
        name: "vMallProductAttr",
        component: () => import("@/views/vMall/pms/productAttr/index"),
        meta: { title: "商品类型", icon: "product-attr" },
      },
      {
        path: "productAttrList",
        name: "productAttrList",
        component: () =>
          import("@/views/vMall/pms/productAttr/productAttrList"),
        meta: { title: "商品属性列表", showHis: false },
        hidden: true,
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/vMall/pms/productAttr/addProductAttr"),
        meta: { title: "添加商品属性", showHis: false },
        hidden: true,
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () =>
          import("@/views/vMall/pms/productAttr/updateProductAttr"),
        meta: { title: "修改商品属性", showHis: false },
        hidden: true,
      },
      {
        path: "productVerify",
        name: "productVerify",
        component: () => import("@/views/mall/manager/product/index"),
        meta: { title: "门店商品审核", icon: "ums-admin" },
      },
      {
        path: "vStoreOrder",
        name: "vStoreOrder",
        component: () => import("@/views/vMall/oms/storeOrder/index"),
        meta: { title: "门店订单" },
      },
    ],
  },

  { path: "*", redirect: "/404", hidden: true },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});



// WEBPACK FOOTER //
// ./src/router/index.js